import {
  Button,
  PageHeader,
  Table,
  Modal,
  Form,
  Row,
  Col,
  Input,
  Descriptions,
  Upload,
  Divider,
  message,
  Space,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { BookTwoTone } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import todayDate from "../../utils/Constants";
import { UploadOutlined, UserAddOutlined,DeleteOutlined,ExclamationCircleOutlined } from "@ant-design/icons";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import apis from "../../services/apis";

const dataSource = [
  {
    key: "1",
    businessname: "Neqat Ltd",
    bankname: "NCB",
    accountnumber: "798789798797",
    action: (
      <>
        <Link to="">Details</Link> <Divider type="vertical" />{" "}
        <Link to="">Edit</Link>
      </>
    ),
  },
  {
    key: "2",
    businessname: "Best Group",
    bankname: "Al Rahji",
    accountnumber: "78987987987",
    action: (
      <>
        <Link to="">Details</Link> <Divider type="vertical" />{" "}
        <Link to="">Edit</Link>
      </>
    ),
  },
];

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
  },
  {
    title: "Business Name",
    dataIndex: "businessname",
    key: "businessname",
  },
  {
    title: "Bank Name",
    dataIndex: "bankname",
    key: "bankname",
  },
  {
    title: "Account Number",
    dataIndex: "accountnumber",
    key: "accountnumber",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

export default function BusinessList() {
  const { businesses, businessdispatch, user } = useApiContext();
  const { Column } = Table;
  const {confirm} = Modal
  const [businessForm] = Form.useForm();
  const navigate = useNavigate();
  const [isopen, setIsopen] = useState(false);
  const [receipt, setReceipt] = useState();
  const [loading, setLoading] = useState(false);
  const [businessEdit, setBusinessEdit] = useState(false);
  const [businessId, setBusinessId] = useState("");
  const [businessData, setbusinessData] = useState();
  const [businessDataa, setbusinessDataa] = useState();
  const [businessDetails, setBusinessDetails] = useState(false);

  useEffect(() => {
    if (businesses.length < 1) apis.Businesses.list(businessdispatch);
    setbusinessDataa(businesses);
  }, [businesses.length<1]);
  const getsearchData = (value) => {
    if (value.target.value === null) setbusinessDataa(businesses);

    var getData = businesses.filter((x) =>
      x.businessName.toLowerCase().includes(value.target.value.toLowerCase())
    );
    setbusinessDataa(getData);
  };

  const onFinish = (values) => {
    if (businessEdit) {
      let newValues = { ...values, id: businessId };
      apis.Businesses.edit(businessdispatch, newValues).then((res) => {
        businessForm.resetFields();
        setLoading(false);
        setIsopen(false);
        setBusinessEdit(false);
      });
    } else {
      setLoading(true);
      let newValues = { ...values, id: uuid() };
      apis.Businesses.create(businessdispatch, newValues).then((res) => {
        message.success("Business Created successfully!");
        businessForm.resetFields();
        setLoading(false);
        setIsopen(false);
      });
    }
  };

  const confirmDelete=(id)=>{
    console.log("business id", id)
    confirm({
      title:"Are you sure you want to delete this item?",
      icon: <ExclamationCircleOutlined />,
      okText:'Yes',
      okType:'danger',
      closable: true,
      onOk(){
        //this.cancelButtonProps={disabled:true}
        return new Promise((resolve,reject)=>{
          apis.Businesses.delete(businessdispatch,id).then(res=>{
            
            resolve("Resolved")
         }).catch(()=>reject("unable to delete"))
        }).catch(()=> message.error("unable to delete"))
      }
    })
  }
  const onFinishFailed = () => { };

  const normFile = (e) => {
    setReceipt(e.file.originFileObj);
    console.log("Upload event:", e.file.originFileObj);

    if (Array.isArray(e)) {
      return e.file.originFileObj;
    }

    return e && e.fileList;
  };

  const editBusiness = (values) => {
    setBusinessEdit(true);
    setIsopen(true);
    setBusinessId(values.id);
    businessForm.setFieldsValue({
      businessName: values.businessName,
      emailAddress: values.emailAddress,
      vatNumber: values.vatNumber,
      phoneNumber: values.phoneNumber,
      address: values.address,
      iBanNumber: values.iBanNumber,
      accountName: values.accountName,
      bankName: values.bankName,
      accountNumber: values.accountNumber,
    });
  };
  const showBusinessDetails = (values) => {
    setbusinessData(values);
    setBusinessDetails(true);
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Business List"
        subTitle="Find all the list of Business here"
        extra={
          <Button
            type="primary"
            onClick={() => setIsopen(true)}
            icon={<BookTwoTone />}
          >
            Add Business
          </Button>
        }
      />
      <Typography.Title level={4}>Filters</Typography.Title>
      <Row>
        <Col span={6}>
          <Form.Item label="Enter Business Name">
            <Input
              placeholder="Enter business name here"
              onKeyUp={(e) => getsearchData(e)}
            />
          </Form.Item>
        </Col>
        {/* <Col span={6} style={{ marginLeft: "10px" }}>
          <Form.Item label="Enter Employee Id">
            <Input
              placeholder="Enter employee id here"
              // onKeyUp={(e) => getsearchDataByEmpId(e)}
            />
          </Form.Item>
        </Col> */}
      </Row>
      {businesses && (
        <Table dataSource={businessDataa}>
          <Column title="Business Name" dataIndex="businessName" key="id" />
          <Column title="VAT Number" dataIndex="vatNumber" key="id" />
          <Column title="Bank Name" dataIndex="bankName" key="id" />
          <Column
            key="id"
            render={(text, record) => (
              <Space size="middle">
                {
                   user.role == "admin" &&
                  <Button
                  type="link"
                  size="small"
                  onClick={() => editBusiness(record)}
                >
                  Edit
                </Button>
                }
                 {
                   user.role == "HR" &&
                  <Button
                  type="link"
                  size="small"
                  onClick={() => editBusiness(record)}
                >
                  Edit
                </Button>
                }
                
                <Button
                  type="link"
                  onClick={() => showBusinessDetails(record)}
                  size="small"
                >
                  View Details
                </Button>
                {
                  user.role == "admin" &&

                  <Button type="link" icon={<DeleteOutlined />} danger onClick={() => confirmDelete(record.id)} size="small">
                    Delete
                  </Button>
                }
              </Space>
            )}
          />
        </Table>
      )}
      <Modal
        visible={isopen}
        title="Add Business"
        footer={null}
        onCancel={() => setIsopen(false)}
        width={900}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          name="basic"
          form={businessForm}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <Row>
            <Divider orientation="left">Business Details</Divider>
            <Col span={12}>
              <Form.Item
                label="Business Name"
                name="businessName"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please enter project name",
                  },
                  {
                    min: 4,
                    message: "Minimum enter 4 characters",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Email Address"
                name="emailAddress"
                rules={[{ type: "email" }, { min: 5, warningOnly: true }]}
                hasFeedback
              >
                <Input type="email" />
              </Form.Item>
              <Form.Item
                name="file"
                label="Upload logo"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload name="file" listType="picture">
                  <Button icon={<UploadOutlined />}>
                    Click to upload logo
                  </Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="VAT Number"
                name="vatNumber"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please enter project name",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Phone Number" name="phoneNumber" hasFeedback>
                <Input />
              </Form.Item>
              <Form.Item
                label="Office Address"
                name="address"
                hasFeedback
                rules={[{ warningOnly: true, min: 4 }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Divider orientation="left">Bank Details</Divider>
            <Col span={12}>
              <Form.Item
                label="IBAN Number"
                name="iBanNumber"
                hasFeedback
                rules={[
                  { required: true, message: "Please enter Iban Number" },
                ]}
              >
                <Input placeholder="IBAN Number" />
              </Form.Item>

              <Form.Item
                label="Bank Name"
                name="bankName"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please enter Bank Name",
                    min: 2,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button
                  type="primary"
                  loading={loading}
                  htmlType="submit"
                  icon={<UserAddOutlined />}
                  style={{ marginRight: "5px" }}
                >
                  {businessEdit ? "Update Business" : "Add Business"}
                </Button>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Account Name"
                name="accountName"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please enter Bank Account name",
                  },
                  {
                    min: 4,
                    message: "Enter minimum 4 characters",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Account Number"
                name="accountNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter account number",
                  },
                ]}
                hasFeedback
              >
                <Input type="number" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        visible={businessDetails}
        title="Business Details"
        footer={null}
        onCancel={() => setBusinessDetails(false)}
        width={900}
      >
        {businessData && (
          <Descriptions bordered labelStyle={{ fontWeight: "bold" }}>
            <Descriptions.Item label="Business Name" span={2}>
              {businessData.businessName}
            </Descriptions.Item>
            <Descriptions.Item label="Email Address">
              {businessData.emailAddress}
            </Descriptions.Item>
            <Descriptions.Item label="Vat Number" span={2}>
              {businessData.vatNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Phone Number">
              {businessData.phoneNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Address" span={2}>
              {businessData.address}
            </Descriptions.Item>
            <Descriptions.Item label="IBAN Number">
              {businessData.iBanNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Account Name" span={2}>
              {businessData.accountName}
            </Descriptions.Item>
            <Descriptions.Item label="Bank Name">
              {businessData.bankName}
            </Descriptions.Item>
            <Descriptions.Item label="Account Number">
              {businessData.accountNumber}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
}
